/*
 * TRC Wellness age gate.
 * Shows an overlay on first visit; dismiss is a single click, remembered for 30 days.
 * The whole page is already rendered underneath — no cloaking, no UA sniffing.
 */
(function () {
  const COOKIE = 'trc_age_ok';
  const DAYS = 30;

  function hasCookie(name) {
    return document.cookie.split('; ').some((c) => c.startsWith(name + '='));
  }

  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value}; expires=${d.toUTCString()}; path=/; SameSite=Lax`;
  }

  function init() {
    const gate = document.getElementById('trc-age-gate');
    if (!gate) return;
    if (hasCookie(COOKIE)) return;

    gate.hidden = false;
    // §1.4 requires the page to be fully rendered underneath — do NOT set
    // body { overflow: hidden }. The gate is position:fixed with a backdrop,
    // so the content behind it is inert visually. This also lets Playwright
    // full-page screenshots capture the whole document height.

    const accept = gate.querySelector('[data-trc-age-gate-accept]');
    if (accept) {
      accept.addEventListener(
        'click',
        function () {
          setCookie(COOKIE, '1', DAYS);
          gate.hidden = true;
        },
        { once: true },
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
